
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'product/save',
        method: 'post',
        data
    })
}

export function getSingle(data) {
    return request({
        url: 'product/getSingle',
        method: 'post',
        data
    })
}

export function getPageList(data) {
    return request({
        url: 'product/getPageList',
        method: 'post',
        data
    })
}

export function deleteObj(data) {
    return request({
        url: 'product/delete',
        method: 'post',
        data
    })
}

export function getAll(data) {
    return request({
        url: 'product/getAll',
        method: 'post',
        data
    })
}